package com.essntl.features.itinerary.domain.repository

import com.essntl.features.itinerary.domain.model.ItineraryFilterOptions
import com.essntl.features.itinerary.domain.model.ItineraryModel
import com.essntl.features.itinerary.domain.model.ItineraryServiceModel
import com.essntl.features.itinerary.domain.model.ItineraryToConfirmModel
import com.essntl.features.proposal.domain.model.fullproposal.FullProposalItineraryModel

interface ItineraryRepository {
    suspend fun get(id: String): Result<ItineraryModel>

    suspend fun getItineraryByShareCode(shareCode: String): Result<ItineraryModel?>

    suspend fun getAll(): Result<List<ItineraryModel>>

    suspend fun getAll(
        page: Long,
        limit: Int = 25,
        filterOptions: ItineraryFilterOptions,
    ): Result<List<ItineraryModel>>

    suspend fun getAllByIds(ids: List<String>): Result<List<ItineraryModel>>

    suspend fun getItinerariesByProposalIds(proposalIds: List<String>): Result<List<ItineraryModel>>

    suspend fun delete(model: ItineraryModel): Result<Unit>

    suspend fun getItineraryService(id: String): Result<ItineraryServiceModel>

    suspend fun getItineraryServicesByIds(ids: List<String>): Result<List<ItineraryServiceModel>>

    suspend fun updateItineraryService(itineraryServiceModel: ItineraryServiceModel): Result<ItineraryServiceModel>

    suspend fun addAllItineraryService(itineraryServiceList: List<ItineraryServiceModel>): Result<List<ItineraryServiceModel>>

    suspend fun getAllItineraryService(
        itineraryId: String,
        excludeStatus: ItineraryServiceModel.Status? = null,
    ): Result<List<ItineraryServiceModel>>

    suspend fun getAllItineraryServiceByStartDate(startDate: String): Result<List<ItineraryServiceModel>>

    suspend fun getAllItineraryServiceByDateRange(
        startDate: String,
        endDate: String,
    ): Result<List<ItineraryServiceModel>>

    suspend fun getAllItineraryToConfirm(
        filterOptions: ItineraryFilterOptions,
    ): Result<List<ItineraryToConfirmModel>>

    suspend fun getFullItineraryById(id: String): Result<FullProposalItineraryModel>

    suspend fun getFullItineraryByShareCode(shareCode: String): Result<FullProposalItineraryModel>

    suspend fun updateItineraryServiceStatuses(
        itineraryServices: List<ItineraryServiceModel>
    ): Result<List<ItineraryServiceModel>>
}
